import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  info: {
    height: 24,
    width: 24,
    paddingLeft: 2,
    cursor: 'pointer'
  },
  smallIcon: {
    height: 14,
    width: 14,
    marginLeft: 5,
    cursor: 'pointer'
  },
  icon16: {
    height: 16,
    width: 16,
    marginLeft: 5,
    cursor: 'pointer'
  },
  icon10: {
    height: 10,
    width: 10,
    marginLeft: 5,
    cursor: 'pointer'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24
  },
  tooltip: ({ size }) => ({
    margin: theme.spacing(0, 1),
    backgroundColor: theme.colorPalette.green_75,
    fontSize: size === 'small' ? 10 : 14
  }),
  arrow: {
    color: theme.colorPalette.green_75
  },
  // Resets a native button so the toggleOnClick trigger looks like the span it replaces.
  toggleButton: {
    appearance: 'none',
    border: 0,
    background: 'none',
    padding: 0,
    margin: 0,
    lineHeight: 'inherit',
    textAlign: 'inherit',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '1px solid currentColor',
      outlineOffset: 2
    }
  },
  toggleIconButton: {
    display: 'inline-flex',
    alignItems: 'center',
    // A 24px-wide hit target; the larger vertical negative margin keeps the icon from making its line taller.
    padding: theme.spacing(1.5),
    margin: theme.spacing(-2, -1.5)
  },
  labelWrapper: ({ height }) => ({
    zIndex: 98,
    height: height || 'unset'
  }),
  desktopLabel: {
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    color: theme.palette.secondary.main,
    textTransform: 'none',
    fontFamily: 'Libre Franklin',
    cursor: 'pointer'
  },
  labelNextToText: {
    paddingLeft: theme.spacing(2)
  },
  formField: {
    position: 'absolute',
    padding: theme.spacing(1),
    right: theme.spacing(2),
    top: theme.spacing(-0.5)
  }
});

export default makeStyles(styles);
